/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Typography, Box, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from "@material-ui/core/Button";
import { ToastContainer, toast } from 'react-toastify';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import CSVReader from 'react-csv-reader';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import SearchNotFound from '../../../SearchNotFound';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function AddHartiPrice(props) {

  const navigate = useNavigate();
  const screenCode = 'ADDHARTIPRICE';
  const [isUploadButtonEnable, setIsUploadButtonEnable] = useState(true);
  const [isTableEnable, setIsTableEnable] = useState(true);
  const [farmersCSVData, setFarmersCSVData] = useState([]);
  const [isFileChosen, setIsFileChosen] = useState(false);
  const [fileInfo, setFileInfo] = useState({});
  const [hartiBulkUpload, setHartiBulkUpload] = useState([]);
  const [Datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate()));

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T', 1)
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Upload",
    pageheadername: "Harti Price Bulk Upload"
  });

  const ProductSaveSchema = Yup.object().shape({
    date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      date: formData.date
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        UpdateProduct(values, pageProps.editingID)
      } else {
        trackPromise(saveHartiPrice());
      }
    },
  });

  const { handleSubmit } = formik;

  useEffect(() => {
    setHartiBulkUpload([]);
    setIsTableEnable(true);
    clearAll();
  }, [Datevalue]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - hartiBulkUpload.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function saveHartiPrice() {
    let duplicate = duplicateCheck();
    if (hartiBulkUpload.length > 0) {
      if (duplicate.length == 0) {
        var res = await services.saveHartiPrice(hartiBulkUpload);
        if (res.statusCode == 'Success') {
          toast.success(res.message);
          clearAll();
        }
        else {
          toast.error(res.message);
        }
      }
      else {
        toast.error("Duplicate Harti Price Detected.");
      }
    }
    else {
      toast.error("Please select a correct file.");
    }
  }

  async function assginMarket(data, type) {
    if (type.type === "text/csv") {
      setHartiBulkUpload([])
      let datarest = await Promise.all(data.map(async data => {

        var hartiDetails = {
          date: new Date(Datevalue),
          productName: data.productName,
          productCode: data.productCode,
          marketCode: data.marketCode,
          marketName: data.marketName,
          minPrice: parseFloat(data.minPrice),
          maxPrice: parseFloat(data.maxPrice),
          createdBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        setHartiBulkUpload(hartiBulkUpload => [...hartiBulkUpload, hartiDetails]);
        setIsTableEnable(false)
      }))

      var errorList = [];
      datarest.map((itemx) => {
        if (itemx != undefined) {
          errorList.push(itemx);
        }
      })
      setFarmersCSVData(errorList);
    }

    else {
      toast.error(type.name + " is not valid . please select a CSV file.");
      setTimeout(() => {
      }, 3000);
    }
  }

  function duplicateCheck() {
    let newRes = _.cloneDeep(hartiBulkUpload);
    var result = [];
    var duplicates = [];
    newRes.forEach(x => {

      var duplicateMarket = result.find(y => y.marketCode === x.marketCode && y.productCode === x.productCode);
      if (duplicateMarket != undefined) {
        duplicates.push(duplicateMarket);
      }
      result.push(x);
    });
    return duplicates;
  }

  async function clearAll() {
    var hartiDetails = {
      productName: "",
      productCode: "",
      date: Datevalue,
      marketCode: "",
      marketName: "",
      minPrice: 0,
      maxPrice: 0,
    }
    setHartiBulkUpload([hartiDetails]);
    setIsFileChosen(false);
    setIsUploadButtonEnable(true);
    setIsTableEnable(true)
    document.querySelector('.csv-input').value = '';
  }

  const papaparseOptions = {
    header: true,
    dynamicTyping: false,
    quoteChar: '"',
    skipEmptyLines: true,
    parseNumbers: true,
    transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '')
  };

  const handleForce = (data, fileInfo) => {
    //if (farmersCSVData != null) {
    setIsFileChosen(true);
    setFileInfo(fileInfo);
    assginMarket(data, fileInfo);
    confirmUpload(data, fileInfo);
    //}
  }

  function confirmUpload(data, fileInfo) {
    setFarmersCSVData(data);
  }

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADDHARTIPRICE');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
  }

  const csvHeaders = [
    { label: "productName", key: "productName" },
    { label: "productCode", key: "productCode" },
    { label: "marketCode", key: "marketCode" },
    { label: "marketName", key: "marketName" },
    { label: "minPrice", key: "minPrice" },
    { label: "maxPrice", key: "maxPrice" },
  ];

  const csvData = [
    {
      productName: "", productCode: "", marketCode: "", marketName: "", minPrice: "", maxPrice: "",
    },
  ];

  const csvData2 = [
    {
      productName: "Mango", productCode: "FT100", marketCode: "NUWARAELIYA", marketName: "Colombo", minPrice: "100", maxPrice: "100",
    },
  ];

  return (
    <>
      <LoadingComponent />
      <Page title="Harti Price Bulk Upload  |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard"
            btname="Back"
            pageName={pageProps.pageheadername}
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      size="small"
                      label="Date *"
                      openTo="day"
                      type="Date"
                      views={['year', 'month', 'day']}
                      value={Datevalue}
                      onChange={(newValue) => {
                        setDateValue(newValue);
                      }}
                      renderInput={(params) =>
                        <TextField
                          width="100"
                          size="small"
                          {...params}
                        />}
                    />
                  </LocalizationProvider>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button variant="contained" color='secondary' component="span"
                    disabled={formik.values.groupID == 0 || formik.values.operationEntityID == 0 ? true : false}>
                    <CSVReader
                      label={isFileChosen ? 'File Chosen' : 'Choose File'}
                      inputStyle={{ display: 'none' }}
                      onFileLoaded={handleForce}
                      parserOptions={papaparseOptions}
                      inputId="react-csv-reader-input"
                      cssClass="csv-reader-input"
                    />
                  </Button>
                  {isFileChosen ? <span>{fileInfo.name}</span> : null}
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Harti Price Bulk Template.csv"}
                    >
                      Template
                    </CSVLink>
                  </Button>
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData2}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Harti Price Bulk Sample Template.csv"}
                    >
                      Sample Data
                    </CSVLink>
                  </Button>
                </Stack>
                <br />
                <Divider variant="middle" />
                <br />
                {duplicateCheck().length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Typography variant="h7" gutterBottom>
                      Duplicate Harti Price Count : {duplicateCheck().length}
                    </Typography>
                  </Stack> : null}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Product Name</TableCell>
                              <TableCell align="center">Product Code</TableCell>
                              <TableCell align="center">Market Name</TableCell>
                              <TableCell align="center">Market Code</TableCell>
                              <TableCell align="center">Min Price</TableCell>
                              <TableCell align="center">Max Price</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(rowsPerPage > 0
                              ? hartiBulkUpload.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : hartiBulkUpload
                            ).map((row, index, array) => {
                              const isDuplicate = array.findIndex((item) => item.marketName === row.marketName && item.productCode === row.productCode) !== index;
                              return (
                                <TableRow
                                  key={row.marketName}
                                  style={{
                                    backgroundColor: isDuplicate ? '#FFEBEE' : 'inherit'
                                  }}
                                >
                                  <TableCell align="center">
                                    {row.productName}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.productCode}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.marketName}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.marketCode}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.minPrice}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.maxPrice}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}
                          </TableBody>

                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={6}
                                count={hartiBulkUpload.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    'aria-label': 'rows per page',
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack> : <SearchNotFound searchQuery="Harti Price Bulk Upload" />}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <LoadingButton
                      size="small"
                      type="button"
                      color='error'
                      variant="outlined"
                      disabled={pageProps.isEdit}
                      onClick={() => clearAll()}
                    >
                      Clear
                    </LoadingButton>
                    <LoadingButton
                      size="small"
                      type="submit"
                      color='secondary'
                      variant="outlined"
                      disabled={isTableEnable}
                    >
                      {pageProps.submitButtonName}
                    </LoadingButton>
                  </Stack> : null}
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}